import { render } from "./UiArticleBody.vue?vue&type=template&id=0c3c5ef3&scoped=true"
import script from "./UiArticleBody.vue?vue&type=script&lang=js"
export * from "./UiArticleBody.vue?vue&type=script&lang=js"

import "./UiArticleBody.vue?vue&type=style&index=0&id=0c3c5ef3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c3c5ef3"

export default script